export class PokemonBadge {
  constructor() {
    return function (items) {
      if (items > 9) {
        return items = '9+';
      } else {
        return items;
      }
    };
  }
}
